<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-descriptions title="快递信息" size="medium" direction="horizontal" :column="4">
      <el-descriptions-item label="运单号">{{ form.kdCode }}</el-descriptions-item>
      <el-descriptions-item label="物流公司" :span="3">{{ form.kdName }}</el-descriptions-item>
      <el-descriptions-item label="收货地址" :span="4">{{ form.linkaddr }}</el-descriptions-item>
      <el-descriptions-item label="发货时间" :span="4">{{ form.kdDate }}</el-descriptions-item>
    </el-descriptions>
    <div class="kd-detail">
      <div class="kd-status">已签收</div>
      <el-timeline>
        <el-timeline-item
          v-for="(item, index) in kdDetail"
          :key="index"
          hide-timestamp
          :class="index==0&&'first'"
          :size="index==0?'large':'normal'"
          :timestamp="item.date"
        >
          <h4>{{ item.date }}</h4>
          <p>{{ item.message }}</p>
        </el-timeline-item>
      </el-timeline>
    </div>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaShipmentsWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        code: '',
        kdId: '',
        kdInfo: '',
        kdName: '',
        kdCode: '',
        kdDate: '',
        linkaddr: ''
        // isdeleted: '',
        // name: '',
        // info: '',
        // type: '',
        // module: '',
        // parentId: '',
        // sortnum: '',
        // status: '',
        // imgurl: ''
      },
      kdDetail: [
        { date: '2022-11-03 23:30:43', message: '已发货' },
        { date: '2022-11-03 23:30:43', message: '已发货' },
        { date: '2022-11-03 23:30:43', message: '已发货' },
        { date: '2022-11-03 23:30:43', message: '已发货' },
        { date: '2022-11-03 23:30:43', message: '已发货' },
      ],
      // 验证规则
      
    }
  },
  
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
  },
  
  methods: {
    // 上传图片
    
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";

::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}

</style>
